{
  "ApiKeys_AddMode": "Sie müssen zuerst einen Benutzer erstellen, bevor Sie einen API-Schlüssel erstellen können.",
  "ApiKeys_Add_New": "Neuen API-Schlüssel hinzufügen ...",
  "ApiKeys_RevokeButton": "Widerrufen",
  "ApiKeys_RemoveButton": "Löschen",
  "ApiKeys_TableHeader_Name": "Name",
  "ApiKeys_TableHeader_Expiry": "Ablauf",
  "ApiKeys_TableHeader_Created": "Erstellt",
  "ApiKeys_TableHeader_LastAccessed": "Letzter Zugriff",
  "ApiKeys_TableHeader_Title": "API-Schlüssel",
  "ApiKeys_Validations_Required": "Erforderlich",
  "ApiKeys_Name_Validations_MaxLength": "Die maximale Länge beträgt 50",
  "ApiKeys_Revoke_ConfirmMessage": "Möchten Sie diesen API-Schlüssel wirklich widerrufen?",
  "ApiKeys_Revoke_Confirm": "Bestätigen",
  "ApiKeys_Revoke_Cancel": "Stornieren",
  "ApiKeys_Indefinite": "Niemals",
  "ApiKeys_Expired": "Abgelaufen",
  "ApiKeys_Placeholder_Description": "Beschreibung",
  "ApiKeys_KeyDisplay_Title": "Zugriffstoken erstellt: \"{}\"",
  "ApiKeys_KeyDisplay_SubTitle": "Notieren Sie dieses Token an einem sicheren Ort. Es kann nicht angezeigt oder abgerufen werden, sobald Sie dieses Fenster schließen oder einen anderen Schlüssel hinzufügen.",
  "ApiKeys_Copy_Success": "In die Zwischenablage kopiert",
  "ApiKeys_Copy_Fail": "Kopieren in die Zwischenablage fehlgeschlagen",
  "ApiKeys_MaxAPIKeysReached": "Sie haben die maximale Anzahl an API-Schlüsseln erreicht. Bitte löschen Sie einen vorhandenen Schlüssel, bevor Sie einen neuen erstellen können.",
  "NAME": "ApiKeys"
}